import React from 'react';
import Main from './Main';
import { useAppContext } from '../../context/AppContext';
const Dashboard = () => {
  const {authState} = useAppContext()

  console.log(authState)


  return (
    <>
    {}
     <Main />
    </>
  );
};

export default Dashboard;
